import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleassistantComponent } from './simple-icons-googleassistant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleassistantComponent ],
    exports:      [ SimpleIconsGoogleassistantComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleassistantModule {}
